import {combineReducers} from 'redux'
import types from 'actions/types'
import {get} from 'lodash'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_ADD_USER_DIALOG:
      return true
    case types.HIDE_ADD_USER_DIALOG:
      return false
    default:
      return state
  }
}

export const selectedContact = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ADD_USER_DIALOG:
      return null
    case types.HIDE_ADD_USER_DIALOG:
      return null
    case types.UPDATE_ADD_USER_DIALOG:
      return get(action, 'data.contact', state)
    default:
      return state
  }
}

export const errorText = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ADD_USER_DIALOG:
      return null
    case types.HIDE_ADD_USER_DIALOG:
      return null
    case types.UPDATE_ADD_USER_DIALOG:
      return get(action, 'data.errorText', state)
    default:
      return state
  }
}

export const selectedFeatureIds = (state = [], action) => {
  switch (action.type) {
    case types.SHOW_ADD_USER_DIALOG:
      return []
    case types.HIDE_ADD_USER_DIALOG:
      return []
    case types.UPDATE_ADD_USER_DIALOG:
      return get(action, 'data.featureIds', state)
    default:
      return state
  }
}

export const selectedPackages = (state = [], action) => {
  switch (action.type) {
    case types.SHOW_ADD_USER_DIALOG:
      return []
    case types.HIDE_ADD_USER_DIALOG:
      return []
    case types.UPDATE_ADD_USER_DIALOG:
      return get(action, 'data.packages', state)
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  selectedContact,
  errorText,
  selectedFeatureIds,
  selectedPackages,
})
